// extracted by mini-css-extract-plugin
export default {"location":"MediaFolderLocation-module__location_aZFmF","name":"MediaFolderLocation-module__name_uUqYa"};